// extracted by mini-css-extract-plugin
export var buttonContainer = "_72-1";
export var fontSizeSelect = "_72-3";
export var formatSelect = "_72-2";
export var formats = "_72-4";
export var hidden = "_72-5";
export var icon = "_72-6";
export var select = "_72-0";